import { render } from "./ReporteAnulaciones.vue?vue&type=template&id=2c222dfc"
import script from "./ReporteAnulaciones.vue?vue&type=script&lang=js"
export * from "./ReporteAnulaciones.vue?vue&type=script&lang=js"

import "./ReporteAnulaciones.vue?vue&type=style&index=0&id=2c222dfc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__